import './Card.scss'
import { Link } from 'react-router-dom'
export default function Card({title, img, about, link}){

    return(
        <div className="Card">
            <div className="card_body">
                <div className="card_front">
                    <div className="card_img">
                        <img src={img} alt="children" />
                    </div>
                    <div className="card_title">
                        {title}
                    </div>
                </div>
                <div className="card_back">
                    <div className="card_about">{about}</div>
                    {link && <Link to={link}>Детальніше</Link>}
                </div>
                
               
            </div>
        </div>
    )
}